import React from 'react'
import { customRoundOff, getImgSrc, getSignedUnit, NAHelpText } from '../../helpers/GlobalFunctions'
import ErrorMsgBlockComponent from '../Error/ErrorMessageBlock';
import CasePullDropdown from './CasePullDropdown';

export default function TKAResultBoxes(props) {
    const { dropDownButtons, casePull, casePullValue, regions, selectedRegion, disableCasePull, disableRegion, handleCasePull, handleInputChange, caseData, planningToolError } = props;
    return (
        <div className="dashboard-blocks section-wrap px-4 pt-4">
            <div className="row">
                <div className="col-sm-6">
                    <CasePullDropdown
                        dropDownButtons={dropDownButtons}
                        casePull={casePull}
                        casePullValue={casePullValue}
                        regions={regions}
                        selectedRegion={selectedRegion}
                        disableCasePull={disableCasePull}
                        disableRegion={disableRegion}
                        handleCasePull={handleCasePull}
                        handleInputChange={handleInputChange}
                    />
                </div>
                {caseData && <>
                    <div className="col-sm-6 case-count text-end">
                        <p className="case-count-text">
                            Average Plan Output: Based on {caseData.totalCount} procedure{caseData.totalCount > 1 && <span>s</span>}
                        </p>
                    </div>
                </>}
            </div>
            {caseData ? <>
                <div className="d-flex align-items-stretch justify-content-between mt-2">
                    <div className="case-component-div">
                        <label className="case-label-align-top">Varus/Valgus</label>
                        <div className="case-text-align-below">
                            <span className="value">{customRoundOff(caseData.FemurVVComponent)}°</span>
                            <span className="unit ps-1">{getSignedUnit(caseData.FemurVVComponent, 'alignment')}</span>
                        </div>

                        <div className="align-image-text">
                            <div className="align-text-middle">
                                <span className="color-orange-left">
                                    <span className="value">{customRoundOff(caseData.FemurDistalMedialResectionDepth)}</span> <span className="unit">mm</span>
                                </span>
                                <br />
                                <span className="color-orange-left">
                                    <span className="value">{customRoundOff(caseData.TibiaMedialResectionDepth)}</span> <span className="unit">mm</span>
                                </span>
                            </div>
                            <img className="img-bg-color" src={getImgSrc('LeftCoronalView.png')} alt="Resection Frontal Left" />
                            <div className="align-text-middle">
                                <span className="color-purple-right">
                                    <span className="value">{customRoundOff(caseData.FemurDistalLateralResectionDepth)}</span> <span className="unit">mm</span>
                                </span>
                                <br />
                                <span className="color-purple-right">
                                    <span className="value">{customRoundOff(caseData.TibiaLateralResectionDepth)}</span> <span className="unit">mm</span>
                                </span>
                            </div>
                        </div>
                        <div className="case-text-align-below case-text-lower-row">
                            <span className="value">{customRoundOff(caseData.TibiaVVComponent)}°</span>
                            <span className="unit ps-1">{getSignedUnit(caseData.TibiaVVComponent, 'alignment')}</span>
                        </div>
                    </div>
                    <div className="case-component-div">
                        <label className="case-label-align-top">Rotation</label>
                        <div className="case-text-align-below">
                            <span className="value">{customRoundOff(caseData.FemurRotationComponent)}°</span>
                            <span className="unit ps-1">{getSignedUnit(caseData.FemurRotationComponent, 'rotation')}</span>
                        </div>

                        <div className="align-image-text">
                            <div className="align-text-middle-single-point">
                                <span className="color-orange-left">
                                    <span className="value">{customRoundOff(caseData.FemurPosteriorMedialResectionDepth)}</span> <span className="unit">mm</span>
                                </span>
                            </div>
                            <img className="img-bg-color" src={getImgSrc('LeftAxialView.png')} alt="Resection Transverse Left" />
                            <div className="align-text-middle-single-point">
                                <span className="color-purple-right">
                                    <span className="value">{customRoundOff(caseData.FemurPosteriorLateralResectionDepth)}</span> <span className="unit">mm</span>
                                </span>
                            </div>
                        </div>
                        {/* <div className="case-text-align-below case-text-lower-row">
                        <span className="value">{customRoundOff(caseData.TibiaRotationComponent)}°</span>
                        <span className="unit ps-1">{getSignedUnit(caseData.TibiaRotationComponent, 'rotation')}</span>
                    </div> */}
                    </div>
                    <div className="case-component-div">
                        <label className="case-label-align-top">Flexion / Slope</label>
                        <div className="case-text-align-below">
                            <span className="value">{customRoundOff(caseData.FemurFlexionComponent)}°</span>
                            <span className="unit ps-1">{getSignedUnit(caseData.FemurFlexionComponent, 'flexion')}</span>
                        </div>
                        <img className="img-bg-color" src={getImgSrc('SagittalView.png')} alt="ResectionSag" />
                        <div className="case-text-align-below case-text-lower-row">
                            <span className="value">{customRoundOff(caseData.TibiaSlopeComponent)}°</span>
                            <span className="unit ps-1">{getSignedUnit(caseData.TibiaSlopeComponent, 'slope')}</span>
                        </div>
                    </div>
                </div>
                {NAHelpText()}
            </>
                : planningToolError ? <ErrorMsgBlockComponent errorObject={planningToolError} /> : <ErrorMsgBlockComponent noData={true} />}
        </div>
    )
}
